import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	loading: false,
	web_form: null,
	categories: [],
	incident_types: [],
	loadingSubmit: false
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_WEB_FORM_PAGE_REQUEST:
		case ActionTypes.GET_WEB_FORM_PAGE_SUCCESS:
		case ActionTypes.GET_WEB_FORM_PAGE_ERROR:
		case ActionTypes.GET_WEB_FORM_INCIDENT_TYPES_REQUEST:
		case ActionTypes.GET_WEB_FORM_INCIDENT_TYPES_SUCCESS:
		case ActionTypes.GET_WEB_FORM_INCIDENT_TYPES_ERROR:
		case ActionTypes.GET_WEB_FORM_CATEGORIES_REQUEST:
		case ActionTypes.GET_WEB_FORM_CATEGORIES_SUCCESS:
		case ActionTypes.GET_WEB_FORM_CATEGORIES_ERROR:
		case ActionTypes.SUBMIT_WEB_FORM_PAGE_REQUEST:
		case ActionTypes.SUBMIT_WEB_FORM_PAGE_SUCCESS:
		case ActionTypes.SUBMIT_WEB_FORM_PAGE_ERROR:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_WEB_FORM_PAGE_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_WEB_FORM_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}